import styled from 'styled-components'
import { easings } from '../../../styles/vars/easings.style'

export const MapRouteArrow = styled.div`
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  z-index: 3;
`

export const MapRouteWrapper = styled.div`
  height: auto;
  opacity: ${props => (props.inView ? 1 : 0)};
  position: absolute;
  ${props => (props.left !== undefined ? `left: ${props.left}%;` : ``)}
  ${props => (props.right !== undefined ? `right: ${props.right}%;` : ``)}
  ${props => (props.top !== undefined ? `top: ${props.top}%;` : ``)}
  ${props => (props.width !== undefined ? `width: ${props.width}%;` : ``)}
  z-index: 2;

  > svg {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;

    &:last-of-type {
      opacity: 0;
      z-index: 2;
    }
  }

  ${props =>
    props.inView &&
    `
    transition: opacity 2s ${easings.out.quart} 2s;
  `}

  ${props =>
    props.active &&
    `
    z-index: 3;

    > svg:last-of-type {
      opacity: 1
    }

    ${MapRouteArrow} {
      opacity: 1;
    }
  `}
`
